<template>
  <react-wrapper :component="landingPageReact" />
</template>

<script lang="ts">
import LandingPage from '../react-components/pages/landing-page'

export default {
  computed: {
    landingPageReact() {
      return LandingPage
    },
  },
}
</script>
